import { useTranslation } from "react-i18next";

function useLanguageDirection() {
  const { i18n } = useTranslation();

  return i18n.dir();
}

export default useLanguageDirection;
